<template>
    <div>
        <ul class="nav nav-tabs tab-deactive" style="background-color: #eff3f6; border-bottom-color: transparent !important;">
            <li v-for="tag in tags" class="nav-item" style="cursor: pointer;">
                <div @click="routeByTag(tag)" :class="{'nav-link': true, 'active': tag.active}">{{ $t(tag.key) }}</div>
            </li>
        </ul>
        <b-card no-body>
            <b-card-body>
                <router-view v-if="selectedTag" :selectedTag="selectedTag" @changetag="onTagChange"/>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash';
import SiteCard from '../../components/SiteCard';

export default {
    components: {
        SiteCard
    },
    name: 'data-main',
    data() {
        return {
            tags: []
        };
    },
    methods: {
        routeByTag(tag) {
            this.tags.forEach(tag => {
                tag.active = false;
            });
            tag.active = true;
            localStorage.setItem('tags', JSON.stringify(this.tags));
            this.$router.push({name: 'site-data-types', query: {year: this.year, tag: tag.key}});
        },
        init(siteId) {
            siteId = siteId ? siteId : Number(this.route.params.site_id);
            let selectedSite = _.find(this.sites, {id: siteId});
            let tagsFromStorage = localStorage.getItem('tags');
            if (!tagsFromStorage || selectedSite) {
                if (selectedSite && selectedSite.tags.length) {
                    this.tags = this.deepClone(selectedSite.tags);

                    if(this.gbId(this.$store.state.user.customerId)){
                        this.tags = _.filter(this.tags, function(o){
                            return o.key !== 'waste';
                        })
                    }
                    /* if(this.$store.state.user.customerId == 1){
                        this.tags = _.filter(this.tags, function(o){
                            return o.key !== 'waste';
                        })
                    } */

                    let activeTagFromStorage = _.first(_.filter(JSON.parse(tagsFromStorage), function(o) {
                        return o.active == true;
                    }));
                    if (activeTagFromStorage !== undefined) {
                        this.tags.forEach(tag => {
                            tag.active = tag.key == activeTagFromStorage.key;
                        });
                    }

                    let activeTags = _.filter(this.tags, function(o) {
                        return o.active == true;
                    });
                    // if any tag is not chosen, set defaul selected tag as first tag(consumption)
                    if (_.isEmpty(activeTags)) {
                        this.tags[0].active = true;
                    }
                } else {
                    this.$router.push('/');
                }
            } else {
                this.tags = JSON.parse(tagsFromStorage);
                if(this.gbId(this.$store.state.user.customerId)){
                    this.tags = _.filter(this.tags, function(o){
                        return o.key !== 'waste';
                    })
                }
            }
        },
        onTagChange(siteId) {
            this.init(siteId);
        }
    },
    computed: {
        selectedTag() {
            let found = _.find(this.tags, {active: true});
            return found ? found.key : null;
        }
    },

    created() {
        this.init();
    }
};
</script>

<style lang="scss">
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "waste": "Atık",
            "energy": "Enerji",
            "water": "Su",
            "other": "Diğer",
            "consumption": "Enerji",
            "supplychain": "Diğer"
        },
        "en": {
            "waste": "Waste",
            "energy": "Energy",
            "water": "Water",
            "other": "Other",
            "consumption": "Energy",
            "supplychain": "Other"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Data/Main.vue